import ConfirmModal from 'components/ConfirmModal'
import ImportModal from 'components/ImportModal'
import {Modal} from 'react-bootstrap'
import {
  V1_IMPORT_ITEMS,
  V1_IMPORT_ITEMS_TEMPLATE,
  V1_IMPORT_ITEMS_TEMPORARY
} from 'api/items/constants'
import {
  hideImportModal,
  onSuccessImport
} from 'actions/library/item'
import * as actNotif from 'actions/notifications'
import * as apiIng from 'api/ingredients'
import * as act from 'actions'

function capitalizeFirstLetter (string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

class ItemImportModal extends ImportModal {
  static SELECT_TYPE = 'select_type'
  static SHOW_IMPORT_MODAL = 'show_import_modal'
  static SHOW_CONFIRM_MODIFY_MODAL = 'show_confirm_modify_modal'
  state = {
    act: ItemImportModal.SHOW_IMPORT_MODAL,
    type: 'modify'
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({
        act: ItemImportModal.SELECT_TYPE,
        type: 'modify'
      })
    }
  }

  render () {
    const replace = this.state.type === 'replace'
    const modify = this.state.type === 'modify'
    return <div>
      {this.state.act !== ItemImportModal.SHOW_CONFIRM_MODIFY_MODAL &&
      <ImportModal
        pathImporting='outlet'
        selectedOutletIds={this.props.selectedOutletIds}
        dispatch={this.props.dispatch}
        templateImportUrl={V1_IMPORT_ITEMS_TEMPLATE}
        temporaryImportUrl={V1_IMPORT_ITEMS_TEMPORARY}
        importUrl={`${V1_IMPORT_ITEMS}?replace=${replace}&modify=${modify}`}
        namespace='items'
        onCancel={this._onCancel}
        onBack={() => {
          this.setState({act: ItemImportModal.SELECT_TYPE})
        }}
        show={this.props.show}
        afterSuccessCallback={() => {
          this.props.dispatch((onSuccessImport()))
        }}
        onErrorCallback={(errors) => {
          this.props.dispatch(actNotif.error(errors[0]))
        }}
        templatePrefix='Item Library - '
        body={this._body()}
        header={this._header()}
        footer={this._footer()}
        eventName={this.state.type}
        filterNamespace='items'
        csvHeaders={['Name', 'Category', 'Description']}
        confirmImportBody={this._confirmImportBody()}
        confirmImportHeader={this._confirmImportHeader()}
        confirmPromiseFunction={this._confirmFunction}
        paramAfterUploadConfirm='&ignore_cogs_validation=true'
        afterUploadConfirmModalHeader={`Confirm Import Items (${capitalizeFirstLetter(this.state.type)})`}
        afterUploadConfirmModalSubHeader='Please confirm import items of the value(s) in field(s) that cannot be updated:'
      />
      }
      <ConfirmModal
        showModal={this.state.act === ItemImportModal.SHOW_CONFIRM_MODIFY_MODAL}
        onHide={this._onHideModal}
        title={'Modify Item'}
        description={(<p>Are you sure you want to modify the item library?<br />If your Item has COGS Tracking OR associated with Recipe, then the Cost Amount of the item cannot be modified</p>)}
        onConfirm={this._onProceed}
        baseColor='danger'
        confirmTitle='Modify'
      />
    </div>
  }

  _onHideModal = () => {
    this.setState({
      act: ItemImportModal.SELECT_TYPE
    })
  }
  _onProceed = () => {
    this.setState({
      act: ItemImportModal.SHOW_IMPORT_MODAL
    })
  }

  _header = () => {
    if (this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
      return null
    } else {
      return <Modal.Title>Choose Import Type</Modal.Title>
    }
  }

  _footer =() => {
    if (this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
      return null
    } else {
      return <div>
        <span className='pull-left'>
          <button onClick={this._onCancel} className='btn btn-default'>Cancel</button>
        </span>
        <span className='pull-right'>
          <button onClick={this._onNext} className='btn btn-primary'>Next</button>
        </span>
      </div>
    }
  }

  _body = () => {
    if (this.state.act === ItemImportModal.SHOW_IMPORT_MODAL) {
      return null
    } else {
      return <div className='modal-below-header'>
        <div className='choose-import-box' onClick={() => { this._onClickType('modify') }}>
          <div className='circle'>{this.state.type === 'modify' ? '✓' : ''}</div>
          <div className='label-modify-item-library'>
           Modify Item Library
         </div>
          <div className='description'>
           Add new items and update your existing ones. Items cannot be deleted, only altered
         </div>
        </div>
        <div className='choose-import-box' onClick={() => { this._onClickType('replace') }}>
          <div className='circle'>{this.state.type === 'replace' ? '✓' : ''}</div>
          <div className='label-modify-item-library'>
           Replace Item Library
         </div>
          <div className='description'>
           Overwrite your existing items. All items will be deleted and replaced
         </div>
        </div>
      </div>
    }
  }

  _confirmImportBody = () => {
    return <p>
      Are you sure you want to replace the item library?<br />
      If you replace the item library, all recipes will be deleted
    </p>
  }

  _confirmImportHeader = () => {
    return 'Replace Item'
  }

  /**
   * return true if items have recipe, it means user must confirm all recipes must be deleted first
   * @return {Promise}
   * @private
   */
  _confirmFunction = () => {
    return new Promise((resolve, reject) => {
      if (this.state.type === 'modify') {
        resolve(false)
      }
      act.showLoadingSpinner(true)
      apiIng.getHaveRecipe({}).then(response => {
        act.showLoadingSpinner(false)
        resolve(response.data.is_recipe)
      }).catch(error => {
        act.showLoadingSpinner(false)
        reject(error.message)
      })
    })
  }

  _onCancel =() => {
    this.props.dispatch(hideImportModal())
  }

  _onNext = () => {
    if (this.state.type === 'modify') {
      this.setState({
        act: ItemImportModal.SHOW_CONFIRM_MODIFY_MODAL
      })
    } else {
      this.setState({
        act: ItemImportModal.SHOW_IMPORT_MODAL
      })
    }
  }

  _onClickType = (type) => {
    this.setState({
      type
    })
  }
}

export default ItemImportModal



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemImportModal/ItemImportModal.js